export const PREFIX = 'screenInstruction:';
export function markScreenInstructionsAsRead(id: string) {
  localStorage.setItem(PREFIX + id, 'true');
}
export function markScreenInstructionsAsUnread(id: string) {
  localStorage.setItem(PREFIX + id, 'false');
}
export function isScreenInstructionRead(id: string): boolean {
  return localStorage.getItem(PREFIX + id) === 'true';
}
